const LAYOUT_EN_LOWER = [
  'q',
  'w',
  'e',
  'r',
  't',
  'y',
  'u',
  'i',
  'o',
  'p',
  '[',
  ']',
  'a',
  's',
  'd',
  'f',
  'g',
  'h',
  'j',
  'k',
  'l',
  ';',
  "'",
  'z',
  'x',
  'c',
  'v',
  'b',
  'n',
  'm',
  ',',
  '.',
  '`',
  '/',
];
const LAYOUT_EN_UPPER = [
  'Q',
  'W',
  'E',
  'R',
  'T',
  'Y',
  'U',
  'I',
  'O',
  'P',
  '{',
  '}',
  'A',
  'S',
  'D',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  ':',
  '"',
  'Z',
  'X',
  'C',
  'V',
  'B',
  'N',
  'M',
  '<',
  '>',
  '~',
  '?',
];
const LAYOUT_RU_LOWER = [
  'й',
  'ц',
  'у',
  'к',
  'е',
  'н',
  'г',
  'ш',
  'щ',
  'з',
  'х',
  'ъ',
  'ф',
  'ы',
  'в',
  'а',
  'п',
  'р',
  'о',
  'л',
  'д',
  'ж',
  'э',
  'я',
  'ч',
  'с',
  'м',
  'и',
  'т',
  'ь',
  'б',
  'ю',
  'ё',
  '.',
];
const LAYOUT_RU_UPPER = [
  'Й',
  'Ц',
  'У',
  'К',
  'Е',
  'Н',
  'Г',
  'Ш',
  'Щ',
  'З',
  'Х',
  'Ъ',
  'Ф',
  'Ы',
  'В',
  'А',
  'П',
  'Р',
  'О',
  'Л',
  'Д',
  'Ж',
  'Э',
  'Я',
  'Ч',
  'С',
  'М',
  'И',
  'Т',
  'Ь',
  'Б',
  'Ю',
  'Ё',
  ',',
];

const RECOGNIZABLE = [...LAYOUT_EN_LOWER, ...LAYOUT_EN_UPPER, ...LAYOUT_RU_LOWER, ...LAYOUT_RU_UPPER];

function tryEn(char: string): string | null {
  if (LAYOUT_EN_LOWER.includes(char)) {
    return LAYOUT_RU_LOWER[LAYOUT_EN_LOWER.indexOf(char)];
  }

  if (LAYOUT_EN_UPPER.includes(char)) {
    return LAYOUT_RU_UPPER[LAYOUT_EN_UPPER.indexOf(char)];
  }

  return null;
}

function tryRu(char: string): string | null {
  if (LAYOUT_RU_LOWER.includes(char)) {
    return LAYOUT_EN_LOWER[LAYOUT_RU_LOWER.indexOf(char)];
  }

  if (LAYOUT_RU_UPPER.includes(char)) {
    return LAYOUT_EN_UPPER[LAYOUT_RU_UPPER.indexOf(char)];
  }

  return null;
}

export function switchLayout(term: string): string {
  const fromRu = /[а-яА-ЯЁё]/.test(term);

  return [...term]
    .map((char) => {
      if (!RECOGNIZABLE.includes(char)) {
        return char;
      }

      const match = fromRu ? tryRu(char) || tryEn(char) : tryEn(char) || tryRu(char);

      return match || char;
    })
    .join('');
}
